import React from 'react';
import { isEmpty } from 'lodash/lang';

import './CommentSection.scss';

export default function CommentSection({ snapshotData, context }) {
  const { commentAnswer } = snapshotData,
    commentPopulatedValue = commentAnswer?.stringValue;

  const isEmptyCommentArea = isEmpty(commentPopulatedValue);

  if (isEmptyCommentArea) {
    return null;
  }

  return (
    <div className="eds-comment-section">
      <div className="edit-comment-area">
        <div className="comment">{commentPopulatedValue}</div>
      </div>
    </div>
  );
}
